<template>
  <article class="registration-steps">
    <h2 class="registration-steps__title">Passo 2</h2>

    <div class="registration-steps__wrapper">
      <p class="registration-steps__message">
        <big><strong>
        Agora escolha pelo menos 3 horários para os pacientes do Dr. Conecta
        </strong></big>
      </p>

      <p class="registration-steps__message">
        <big>
        <strong>Atenção:</strong> cada horário deve ter, no mínimo, o tempo <br>
        médio da sua consulta, que tem duração de
        <strong>{{ interval | TO_HOUR_MINUTE_FORMAT }}</strong>
        </big>
      </p>

      <ul class="drconecta-days">
        <li v-for="(weekday, $index) of weekdaysSelected" :key="$index" class="drconecta-days__day">
          <article class="card">
            <header class="card-header">
              <div class="card-title">{{weekday.day}}</div>
            </header>

            <main class="card-body">
              <fieldset class="form-group">
                <label for="das">das </label>
                <div class="d-flex">
                  <select @change="selectStart($index)" class="form-select" v-model="weekday.start.hours">
                    <option disabled>HH</option>
                    <option v-for="n in 24" :selected="n === 12" :key="n" :value="n">
                      {{ String(n).padStart(2, 0) }}
                    </option>
                  </select>
                  :
                  <select class="form-select" v-model="weekday.start.minutes">
                    <option disabled>MM</option>
                    <option
                      v-for="i of Array.range(0, 59, 5)"
                      :value="String(i).padStart(2, 0)"
                      :selected="i === 0"
                      :key="'minuteend' + i">
                      {{ String(i).padStart(2, 0) }}
                    </option>
                  </select>
                </div>
              </fieldset>

              <fieldset class="form-group">
                <label for="as">às</label>
                <div class="d-flex">
                  <select class="form-select" v-model="weekday.end.hours">
                    <option v-for="n in 23" v-show="n >= weekday.start.hours" :selected="weekday.start.hours + 1" :key="n" :value="n">
                      {{ String(n).padStart(2, 0) }}
                    </option>
                  </select>
                  :
                  <select class="form-select" v-model="weekday.end.minutes">
                    <option disabled>MM</option>
                    <option
                      v-for="i of Array.range(0,59,5)"
                      :value="String(i).padStart(2,0)"
                      :selected="i === 0"
                      :key="'minuteend' + i">
                      {{ String(i).padStart(2, 0) }}
                    </option>
                  </select>
                </div>
              </fieldset>

              <button @click="addPeriod($index, weekday.start, weekday.end)" class="btn btn-white">Adicionar período</button>
            </main>
          </article>

          <footer class="card-footer text-right drconecta-days__periods">
            <transition-group name="fade">
              <span class="chip text-italic" v-for="(time, $index) of weekday.periods" :key="'period' + $index">
                <dr-icon fill="white" name="agenda2"></dr-icon>
                das {{ time.start }}
                às {{ time.end }}
                <strong @click="removePeriod(weekday.day, $index)" class="close"></strong>
              </span>
            </transition-group>
          </footer>
        </li>
      </ul>
      <!-- <button @click="$router.replace({path: '1'})" class="btn">Voltar</button> -->
      <button :disabled="checkPeriods() || sending" @click="next()" class="btn btn-primary">Avançar</button>
    </div>
  </article>
</template>

<script>
Array.range = (from, to, step) => Array.from({length: ~~((to - from) / step) + 1}, (v, k) => from + k * step)

export default {
  props: ['formData'],
  data () {
    return {
      weekdaysSelected: [],
      selectedFrom: {},
      selectedTo: {},
      selectedPeriods: {},
      sending: false
    }
  },
  computed: {
    totalMinutes () {
      let totalMinutes = 0
      this.weekdaysSelected.forEach((day) => {
        totalMinutes += (typeof day.mergedPeriods !== 'undefined' && day.mergedPeriods.length > 0)
          ? this.getTotalMinutes([...day.mergedPeriods])
          : 0
      })
      return totalMinutes
    },
    interval () {
      const interval = this.$store.getters.getRegistrationAppointmentInterval.split(':')
      return (parseInt(interval[0]) * 60) + parseInt(interval[1])
    }
  },
  filters: {
    TO_HOUR_MINUTE_FORMAT (period) {
      let hours = (Math.floor(period / 60) > 0) ? `${Math.floor(period / 60)}h` : ''
      let minutes = (period % 60 > 0) ? `${`0${period % 60}`.substr(-2)}min` : ''
      return `${hours}${minutes}`
    }
  },
  mounted () {
    for (let day of this.formData.weekdaysSelected) {
      let selectedDay = {
        day: day,
        start: { hours: '12', minutes: '00' },
        end: { hours: '13', minutes: '00' },
        periods: [],
        mergedPeriods: []
      }
      this.weekdaysSelected.push(selectedDay)
    }
    this.fn_HIDE_PROGRESS()
  },
  methods: {
    next () {
      this.$emit('step-change', ['periodsSelected', this.weekdaysSelected])
      this.fn_SHOW_PROGRESS()
      this.sending = true
      let data = []
      for (let exclusiveDaysAgendas of this.weekdaysSelected) {
        let obj = {
          dayOfWeek: this.fn_TO_WEEKDAY(exclusiveDaysAgendas.day),
          exclusivePeriodAgendas: []
        }
        if ('mergedPeriods' in exclusiveDaysAgendas) {
          for (let exclusivePeriod of exclusiveDaysAgendas.mergedPeriods) {
            obj.exclusivePeriodAgendas.push({
              periodStart: exclusivePeriod.start,
              periodStop: exclusivePeriod.end
            })
          }
          data.push(obj)
        }
      }

      this.$http.post(
        `/doctor/doctor_office/agenda_setting`,
        { exclusive_days_agenda: { exclusiveDaysAgendas: data } },
        this.$store.getters.getAuthHeader
      )
        .then(
          (res) => {
            this.sending = false
            this.$router.push({path: '/register/' + this.$route.params.id + '/doctor-office/agenda/status'})
          }
        ).catch(
          (err) => {
            console.log('err\n', err)

            const msgErro = ('errors' in err) ? this.findErrorMessage(err.errors)[0] : 'Ocorreu um erro'

            this.$store.dispatch('setModalAlert', {
              title: 'Erro',
              body: msgErro,
              size: 'md',
              active: true
            })

            this.sending = false
          }
        ).finally(() => {
          this.fn_HIDE_PROGRESS()
        })
    },
    checkSelected (day) {
      if (this.weekdaysSelected.indexOf(day) > -1) {
        return 'selected'
      }
    },
    checkPeriods () {
      return !(
        (this.weekdaysSelected.every(day => day.periods.length > 0)) &&
        (this.weekdaysSelected.every(day => day.mergedPeriods.every(period => period.minutes >= this.interval))) &&
        (this.totalMinutes >= 3 * this.interval)
      )
    },
    addPeriod (index, start, end) {
      const period = Object.freeze({
        start: `${start.hours}:${start.minutes}`,
        end: `${end.hours}:${end.minutes}`
      })

      if (this.convertIntervalToMinutes(period.start, period.end) < this.interval) {
        const errorMessage = {
          title: 'Erro',
          body: 'O horário escolhido é menor que o tempo médio de consulta informado.',
          active: true,
          size: 'sm',
          callback: null
        }
        this.$store.dispatch('setModalAlert', errorMessage)
        return
      }

      if (this.weekdaysSelected[index].periods.length >= 1) {
        const add = !this.weekdaysSelected[index].periods.some(time => (time.start === period.start) && (time.end === period.end)
        ) && (period.start !== period.end)
        if (add) {
          this.weekdaysSelected[index].periods.push(period)
        }
      } else {
        this.weekdaysSelected[index].periods.push(period)
      }

      this.weekdaysSelected[index].periods.sort((a, b) => parseInt(a.start.replace(':', '')) - parseInt(b.start.replace(':', '')))
      this.weekdaysSelected[index].mergedPeriods = this.mergeIntervals(this.weekdaysSelected[index].periods)
    },
    removePeriod (day, period) {
      for (let selected of this.weekdaysSelected) {
        if (selected.day === day) {
          selected.periods.splice(period, 1)
          selected.mergedPeriods = [...this.mergeIntervals(selected.periods)]
        }
      }
    },
    mergeIntervals (intervals = []) {
      intervals = JSON.parse(JSON.stringify(intervals))
      let newIntervals = []
      newIntervals = [intervals[0]]

      if (intervals.length > 1) {
        intervals.sort((a, b) => parseInt(a.start.replace(':', '')) - parseInt(b.start.replace(':', '')))

        for (let i = 1; i < intervals.length; i++) {
          const firstIntervalEnd = this.$moment.utc(newIntervals[0].end, 'HH:mm')
          const currentIntervalStart = this.$moment.utc(intervals[i].start, 'HH:mm')
          const currentIntervalEnd = this.$moment.utc(intervals[i].end, 'HH:mm')

          if (currentIntervalStart.isSameOrBefore(firstIntervalEnd) && currentIntervalEnd.isSameOrAfter(firstIntervalEnd)) {
            newIntervals[0].end = intervals[i].end
          }

          if (currentIntervalStart.isAfter(firstIntervalEnd)) {
            newIntervals.unshift(intervals[i])
          }
        }
      }

      newIntervals.sort((a, b) => parseInt(a.start.replace(':', '')) - parseInt(b.start.replace(':', '')))
      newIntervals.forEach((interval) => {
        if (interval) {
          interval.minutes = this.convertIntervalToMinutes(interval.start, interval.end)
        }
      })

      return newIntervals
    },
    getTotalMinutes (intervals) {
      let totalMinutes = 0
      intervals.forEach((interval) => {
        if (interval) {
          totalMinutes += interval.minutes
        }
      })
      return totalMinutes
    },
    convertIntervalToMinutes (start = null, end = null) {
      if (start && end) {
        const intervalStart = this.$moment.utc(start, 'HH:mm')
        const intervalEnd = this.$moment.utc(end, 'HH:mm')
        const intervalMinutes = intervalEnd.diff(intervalStart, 'minutes')

        return intervalMinutes
      }
      return 0
    },
    selectStart (index) {
      const start = this.weekdaysSelected[index].start.hours
      const end = this.weekdaysSelected[index].end.hours

      if (end <= start) {
        this.weekdaysSelected[index].end.hours = start + 1
        this.$forceUpdate()
      }
    },
    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    }
  }
}
</script>
